import InspirationAnalysisDetails from '@/components/InspirationAnalysisDetails'
import { Badge } from '@/components/shadcn/badge'
import { Button } from '@/components/shadcn/button'
import { DataTableColumnHeader } from '@/components/shadcn/data-table'
import { cn } from '@/lib/utils'
import { FunnelCongruenceAnalysisResponse } from '@/routes/funnel-analyzer.index'
import { ColumnDef } from '@tanstack/react-table'
import moment from 'moment'
import { useState } from 'react'

export type HistoryType = {
  analysis: FunnelCongruenceAnalysisResponse
  taskId: string
  createdAt: string
  images: {
    fcImageUrl: string
    landingPageUrl: string | null
    type?: 'ad' | 'landing-page' | undefined
  }[]
  score: number
}

export const historyColumns: ColumnDef<HistoryType>[] = [
  {
    accessorKey: 'taskId',
    header: ({ column }) => <DataTableColumnHeader column={column} title="Item" />,
    cell: (params) => (
      <div className="flex items-center gap-2">
        <span>
          <img
            src={params.row.original.images[0].fcImageUrl}
            alt="ad"
            width={100}
            height={100}
            className="rounded-md object-cover h-[2.75rem] w-[2.75rem]"
          />
        </span>
        <span>+</span>
        <span>
          <img
            src={params.row.original.images[1].fcImageUrl}
            alt="landing-page"
            width={100}
            height={100}
            className="rounded-md object-cover h-[2.75rem] w-[2.75rem]"
          />
        </span>
      </div>
    ),
  },

  {
    accessorKey: 'score',
    header: ({ column }) => <DataTableColumnHeader column={column} title="Score" />,
    cell: (params) => <span className="font-semibold">{params.row.original.score}</span>,
  },
  {
    accessorKey: 'score',
    header: ({ column }) => <DataTableColumnHeader column={column} title="Grade" />,
    cell: (params) => params.row.original.analysis.analysis.coherence_evaluation.overall_score.grade,
  },
  {
    accessorKey: 'score',
    header: ({ column }) => <DataTableColumnHeader column={column} title="Status" />,
    cell: (params) => (
      <div className="flex items-center gap-2">
        <Badge variant={'outline'} className={'flex gap-1'}>
          <span
            className={cn(
              {
                'bg-green-500': params.row.original.score >= 70,
                'bg-orange-500': params.row.original.score >= 50 && params.row.original.score < 70,
                'bg-red-500': params.row.original.score < 50,
              },
              'rounded-full w-1.5 h-1.5',
            )}
          ></span>{' '}
          <span className="text-xs">
            {params.row.original.score >= 70 ? 'Strong' : params.row.original.score >= 50 ? 'Medium' : 'Weak'}
          </span>
        </Badge>
      </div>
    ),
  },
  {
    accessorKey: 'createdAt',
    header: ({ column }) => <DataTableColumnHeader column={column} title="Date Analyzed" />,
    cell: (params) => moment(params.row.getValue('createdAt')).format('MM/DD/YYYY'),
  },
  {
    accessorKey: 'taskId',
    header: ({ column }) => <DataTableColumnHeader column={column} title="Action" />,
    cell: (params) => {
      const [analysisOpen, setAnalysisOpen] = useState<boolean>(false)
      return (
        <div className="flex items-center gap-2">
          <Button size={'sm'} variant={'outline'} onClick={() => setAnalysisOpen(true)}>
            View Analysis
          </Button>
          {analysisOpen && (
            <InspirationAnalysisDetails
              data={params.row.original.analysis}
              open={analysisOpen}
              onOpenChange={() => setAnalysisOpen(false)}
              showUseThisFormatButton={false}
            />
          )}
        </div>
      )
    },
  },
]
